import { domain } from 'modules/data';

export const excludedIntegrationCodes: Array<domain.IntegrationCode | null> = [
    domain.IntegrationCode.NetSuiteExpenseReport,
    domain.IntegrationCode.NetSuiteSalesOrder,
];
